import React from 'react';
import { HelpCircle, MapPin, Users, Building } from 'lucide-react';
import CityLandingPage from './CityLandingPage';

const jamshedpurConfig = {
  city: 'Jamshedpur',
  state: 'Jharkhand',
  canonicalUrl: 'https://nirvanacareercounselling.com/jamshedpur',
  title: 'Best Career Counselling in Jamshedpur | Free First Session | Nirvana',
  description:
    'Expert career counselling in Jamshedpur (Tata Nagar) for students and professionals. Online sessions with a certified counsellor with 30+ years experience. Free first session. Psychometric assessments and career guidance for the Steel City.',
  keywords:
    'career counselling jamshedpur, career counsellor tata nagar, career guidance steel city, best career counsellor jamshedpur, psychometric test jamshedpur, career assessment jamshedpur, career counselling jharkhand, online career counselling jamshedpur, career guidance jamshedpur, career planning tata nagar',
  heroSubtitle: 'Expert Career Guidance for Jamshedpur — 100% Online Sessions',
  localHighlight:
    "Jamshedpur — the Steel City — is home to Tata Steel, major industrial conglomerates, and a growing professional community. We provide career guidance tailored to Jamshedpur's unique landscape: industrial and engineering careers, corporate opportunities within the Tata Group, and pathways beyond the city for higher education and diverse sectors.",
  showRemoteBanner: true,
  ctaNote: 'Online sessions — attend from anywhere in Jamshedpur',
  localFAQs: [
    {
      icon: Building,
      question: 'Do you provide career guidance for Jamshedpur\'s industrial sector?',
      answer:
        "Given Jamshedpur's prominence as a steel and industrial hub, we provide specialized guidance for careers in manufacturing, metallurgy, engineering, and industrial management. Our counselling covers opportunities in major companies like Tata Steel, career progression in technical fields, and emerging opportunities in industrial automation and sustainable manufacturing.",
    },
    {
      icon: HelpCircle,
      question: 'Is career counselling available online in Jamshedpur?',
      answer:
        'Yes! We offer 100% online career counselling for students and professionals in Jamshedpur. Sessions are conducted via video call — there is no need to travel anywhere. You receive the same expert guidance and psychometric assessments as in-person clients.',
    },
    {
      icon: MapPin,
      question: 'My child studies in a Tata school in Jamshedpur — can you help with career guidance?',
      answer:
        'Absolutely. We work with students from Class 2 onwards. Our psychometric assessments are age-appropriate and highly effective for identifying aptitudes early. We regularly help students from Jamshedpur schools plan their subject selections and career trajectories.',
    },
    {
      icon: Users,
      question: 'Can you help Jamshedpur professionals considering a career change outside the industrial sector?',
      answer:
        'Yes. Many professionals from Jamshedpur\'s industrial sector look to transition into management consulting, entrepreneurship, IT, or other sectors. We provide a structured assessment and transition roadmap that helps professionals leverage their existing expertise while moving into new fields.',
    },
  ],
};

const JamshedpurPage = () => <CityLandingPage cityConfig={jamshedpurConfig} />;

export default JamshedpurPage;
